import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from '$src/common/TextInput.css'
import {asField} from '$src/common/forms'

interface Props {
  css?: any
  type?: 'text' | 'password'
  name: string
  label: string
  placeholder?: string
  value: any
  onChange: (v: any) => void
  style?: 'big' | 'small'
}

@observer
export default class TextInput extends Component<Props, {}> {
  static Field: any
  _onChange = (e: any) => {
    this.props.onChange(e.target.value)
  }
  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container', props.style || 'big')}>
        <label {...classes('label')}>{props.label}</label>
        <input
          {...classes('input')}
          type={props.type || 'text'}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          onChange={this._onChange}
        />
      </div>
    )
  }
}

TextInput.Field = asField()(TextInput)



// WEBPACK FOOTER //
// ./src/common/TextInput.tsx